import axios from "axios";
//const jipvioApiBase = process.env.JIPVIO_API_BASE;
const baseUriContSrv = `${process.env.VUE_APP_BASE_URL}/jipviomain/api/v1/contract`;
//const baseUriPropSrv = `http://localhost:9083/jipviomain/api/v1/property`;
export default {
  getContractDetail(contId) {
    return axios({
      method: "get",
      url: `${baseUriContSrv}/${contId}`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          pagingInfo: res.data.pagingInfo,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
